import { AxiosInstance } from 'axios'

import { creditApiDefaultApiFactory } from '@src/api/default-api-factories'

export const getAccountConnectionStatus = async (instance: AxiosInstance) => {
  return await creditApiDefaultApiFactory(
    instance
  ).v1AccountsConnectionStatusGet()
}

// Do Not Remove this line ===@import api client===
